export enum CanadaPostManifestMode {
  ManifestNotRequired = "manifest_not_required",
  ManifestRequired = "manifest_required",
}
